/**
 * 记录ID生成器
 */
const PopupKeyGen = (function* (start) {
    while (true) {
        yield `popup-key-${start++}`;
    }
})(1);
function getKey() {
    return PopupKeyGen.next().value;
}
const PopupManager = {
    getKey,
};
export default PopupManager;
